import React from 'react'

export default class Canary extends React.Component {
    render() {
        return (
            <div className="App">
                <div className={"container"}>
                    {/* origin */}
                    <p>Gooseworks did not respond to any local, state, or federal warrants in calendar year 2024.</p>
                    <p>Gooseworks did not respond to any local, state, or federal warrants in calendar year 2025.</p>
                    <p>Gooseworks has not responded to any local, state, or federal warrants in calendar year 2026.</p>
                </div>
            </div>
        );
    }
}